import Vue from 'vue'

/**
 * @method $setVal 本地存储
 * 
 * @param {string} key   值key
 * @param {string} value 存储的value
 */
Vue.prototype.$setVal = function (key, value) {
    localStorage.setItem(key, value)
}

/**
 * @method $getVal 存储获取
 * 
 * @param {string} key   存储的key
 */
Vue.prototype.$getVal = function (key) {
    return localStorage.getItem(key)
}

/**
 * @method $remoVal     清除存储
 * 
 * @param {string} key   存储的key
 */
Vue.prototype.$remoVal = function (key) {
    localStorage.removeItem(key)
}

/**
 * @method $Telephone     拨打电话
 * 
 * @param {string} tel    电话号码
 */
Vue.prototype.$Telephone = function (tel) {
    let a = document.createElement("a")
    a.href = `tel:${tel}`
    a.click()
    a.remove()
}

/**
 * oneRouter => 路由防抖(禁止重复点击)
 * 
 * @param {String} router
 */
Vue.prototype.$oneRouter = function (router) {
    let pagelink = this.$route.fullPath
    if (router != pagelink) this.$router.push(router)
}

export default Vue